import { Pipe, PipeTransform } from '@angular/core';
import { DevExtremeFieldTypesEnum } from '@views/secured/beyond-smart-reports/enums/dev-extreme-field-types.enum';
import { SelectOptionModel } from '@shared/components/form-elements/select/model/select.option.model';
import {
  SummaryTypeEnum
} from '@views/secured/beyond-smart-reports/views/report/components/devextreme/summaries-dialog/enum/summary-type.enum';

const booleanOperations = [SummaryTypeEnum.COUNT];
const stringOperations = [
  SummaryTypeEnum.COUNT
];
const dateAndDateTimeOperations = [
  SummaryTypeEnum.COUNT,
  SummaryTypeEnum.MIN,
  SummaryTypeEnum.MAX
];
const numberOperations = [
  SummaryTypeEnum.COUNT,
  SummaryTypeEnum.SUM,
  SummaryTypeEnum.MIN,
  SummaryTypeEnum.MAX,
  SummaryTypeEnum.AVG
];

@Pipe({
  name: 'setSummaryType'
})
export class SetSummaryTypePipe implements PipeTransform {

  transform(type: DevExtremeFieldTypesEnum): SelectOptionModel[] {
    switch (type) {
      case DevExtremeFieldTypesEnum.STRING:
        return stringOperations
          .map((value) => ({value, data: this.getSummaryTypeValue(value)}));
      case DevExtremeFieldTypesEnum.DATE_TIME:
        return dateAndDateTimeOperations
          .map((value) => ({value, data: this.getSummaryTypeValue(value)}));
      case DevExtremeFieldTypesEnum.DATE:
        return dateAndDateTimeOperations
          .map((value) => ({value, data: this.getSummaryTypeValue(value)}));
      case DevExtremeFieldTypesEnum.BOOLEAN:
        return booleanOperations
          .map((value) => ({value, data: this.getSummaryTypeValue(value)}));
      case DevExtremeFieldTypesEnum.NUMBER:
        return numberOperations
          .map((value) => ({value, data: this.getSummaryTypeValue(value)}));
      default:
        return stringOperations
          .map((value) => ({value, data: this.getSummaryTypeValue(value)}));
    }
  }

  private getSummaryTypeValue(value: SummaryTypeEnum): string {
    switch (value) {
      case SummaryTypeEnum.COUNT:
        return 'COUNT';
      case SummaryTypeEnum.SUM:
        return 'SUM';
      case SummaryTypeEnum.AVG:
        return 'AVG';
      case SummaryTypeEnum.MAX:
        return 'MAX';
      case SummaryTypeEnum.MIN:
        return 'MIN';
      default:
        return value;
    }
  }
}
